import type { FilterProperty } from '@/components/admin/SysadminSPA/shared/filterTypes';

// AIDEV-NOTE: Ransack filter properties for the Reference Materials table.
// These map to associations/attributes on the ReferenceMaterial model.
const REFERENCE_MATERIAL_FILTER_PROPERTIES: FilterProperty[] = [
  {
    label: 'Program',
    operators: ['eq', 'not_eq'],
    value: 'programs_id',
  },
  {
    label: 'Tag',
    operators: ['eq', 'cont'],
    value: 'tags_value_en',
  },
  {
    isBoolean: true,
    label: 'Published',
    operators: ['eq'],
    value: 'published',
  },
  {
    label: 'Title',
    operators: ['eq', 'not_eq', 'cont', 'not_cont'],
    value: 'reference_material_translations_title',
  },
];

export default REFERENCE_MATERIAL_FILTER_PROPERTIES;
